
import React from 'react';
import { Molecule, wrap, Wrapper } from 'AppReact'
import styled from 'styled-components'
import { GenericWrapper, Mb8, FlexCenterWrapper, Mr2, PrimaryBackground50Wrapper, Px15, } from 'wrappers';
import { SecondaryTextBase300, SecondaryText2xl, SecondaryIconBase300 } from 'atoms';

const template = styled.div``

export default Molecule({
  template,
  type: '',
  atoms: [
    {
      wrapper: wrap(wrap(Px15, Mb8), PrimaryBackground50Wrapper),
      name: 'Wrapper',
      atoms: [
        {
          wrapper: wrap(GenericWrapper, Mb8),
          name: 'Title',
          atoms: [
            {
              wrapper: FlexCenterWrapper,
              name: 'Wrapper',
              atoms: [
                {
                  component: wrap(SecondaryIconBase300, Mr2),
                  name: 'Icon',
                  displayValue: ({ icon }) => icon,
                  renderIf: ({ icon }) => !!icon,
                },
                {
                  component: SecondaryTextBase300,
                  name: 'CreateText',
                  bindings: () => ({}),
                  displayValue: ({ purpose }) => purpose ?? '',
                },
              ]
            },
            {
              component: SecondaryText2xl,
              name: 'Title',
              bindings: () => ({}),
              displayValue: ({ title }) => title ?? '',
            },
          ]
        },
      ]
    }
  ]
})
